import { ImageLoader } from "next/image";
import { curBackend } from "src/config";
import LOCAL_DEV from "src/constants/LOCAL_DEV";

const nextImageLoader: ImageLoader | undefined = LOCAL_DEV
	? undefined
	: ({ src, width, quality }) => {
			// Prepend the current hostname if necessary
			const resolvedSrc = encodeURIComponent(
				src.startsWith("/") && typeof window !== "undefined"
					? window.location.origin + src
					: src,
			);
			return `https://${curBackend}-optimize-image.joinswsh.com/_next/image?url=${resolvedSrc}&w=${width}&q=${quality || 75}`;
		};
export default nextImageLoader;
